import { createAction } from "redux-actions";

export const ToggleUiExpand = createAction("EXPAND_INTERFACE");
export const ToggleModalEdit = createAction("TOGGLE_MODAL_EDIT");



// WEBPACK FOOTER //
// ./src/actions/ui.js